// src/utils/friendlyError.js

/**
 * Map Firebase Auth error codes to friendly messages.
 * Non-Auth errors fall back to a generic message.
 */
export function friendlyAuthMessage(code) {
  const c = String(code || "").toLowerCase();

  // Common auth codes
  if (c.includes("invalid-email")) return "That email address doesn’t look valid.";
  if (c.includes("user-disabled")) return "This account is disabled. Please contact support.";
  if (c.includes("user-not-found")) return "We couldn’t find an account with that email.";
  if (c.includes("wrong-password")) return "That password isn’t correct.";
  if (c.includes("invalid-credential")) return "The email or password is incorrect.";
  if (c.includes("too-many-requests")) return "Too many attempts. Please wait a bit and try again.";
  if (c.includes("network-request-failed")) return "Network error. Check your connection and try again.";
  if (c.includes("popup-closed-by-user")) return "The sign-in window was closed before completing.";
  if (c.includes("internal-error")) return "Something went wrong. Please try again.";

  return null; // unknown
}

/**
 * Generic fallback (non-auth) error mapper.
 */
export function friendlyFromError(err, fallback) {
  // If it looks like a Firebase Auth error:
  if (err && typeof err.code === "string" && err.code.startsWith("auth/")) {
    const msg = friendlyAuthMessage(err.code);
    if (msg) return msg;
  }

  // HTTP-ish errors
  const m = String(err?.message || "").toLowerCase();
  if (m.includes("fetch") && m.includes("failed")) return "Network error. Please try again.";
  if (m.includes("failed to fetch")) return "Network error. Please try again.";
  if (m.includes("permission") || m.includes("forbidden")) return "You don’t have permission for that action.";
  if (m.includes("not found")) return "We couldn’t find what you’re looking for.";

  return fallback || "Something went wrong. Please try again.";
}
